const WHATSAPP_GROUP = {
  DEFAULT_GROUP_URL: 'https://promobit.com.br/messenger/cupons-desconto',
};

export default WHATSAPP_GROUP;
